module.exports = __webpack_public_path__ + "static/karoldanko-85973fa3179dcf341b9db56943747aba.jpg";